import { CHART_COLORS, seriesColumnConfig } from './chartStyle';

/**
 * Configuration function for monthly sales chart.
 * @param {Object} params - The parameters for the monthlySalesChartConfig function.
 * @param {Array} params.monthlySalesChartData - Data for the monthly sales chart.
 * @param {Function} params.t - Translation function for internationalization.
 * @returns {Object} - Configuration object for the monthly sales chart.
 */
export const monthlySalesChartConfig = ({ monthlySalesChartData, t }) => {
  const advancePayment = t('dashboard.tabs.finances.advance_payment');
  const balance = t('dashboard.tabs.finances.balance');

  return {
    ...seriesColumnConfig({
      domain: [advancePayment, balance],
      colors: [CHART_COLORS.cambridge, CHART_COLORS.pear],
      stack: true
    }),
    data: monthlySalesChartData
      .flat(2)
      .filter(({ type }) => type !== t('dashboard.tabs.finances.total')),
    xField: 'month',
    yField: 'sales',
    tooltip: {
      items: [
        (item) => ({
          name: item.type,
          value: `${item.sales.toFixed(2)} €`
        })
      ]
    }
  };
};
